import {
  PortalFooterLinksWidget,
  PortalFooterChannelsWidget,
  DefaultPageWidget,
  DestaquesWidget,
  CharCountWidget,
  ToggleWidget,
  QueryFieldWidget,
  CollectionPreviewWidget,
  HtmlSourceWidget,
  PublicarTambemWidget,
  NewsDescriptionWidget,
  PrivacidadeDadosWidget,
} from '../widgets';

import shareSVG from '@plone/volto/icons/share.svg';
import usersSVG from '@plone/volto/icons/group.svg';
import tagSVG from '@plone/volto/icons/tag.svg';
import InternalUrlWidget from '@plone/volto/components/manage/Widgets/InternalUrlWidget';
import UrlWidget from '@plone/volto/components/manage/Widgets/UrlWidget';
import QuerySortOnWidget from '@plone/volto/components/manage/Widgets/QuerySortOnWidget';
import SelectViewWidget from '@plone/volto/components/theme/Widgets/SelectWidget';
import TemaAcoesWidget from 'volto-ministerio-publico-federal/components/Blocks/OndeAtua/TemaAcoesWidget';

export const updateWidgetsConfig = (config) => {
  config.widgets.id = {
    ...config.widgets.id,
    footer_links: PortalFooterLinksWidget,
    footer_channels: PortalFooterChannelsWidget,
    responsible_news_manager: InternalUrlWidget,
    news_root_path: InternalUrlWidget,
    destaques: DestaquesWidget,
    url: UrlWidget,
    query: QueryFieldWidget,
    customViewFields: CollectionPreviewWidget,
    sort_on: QuerySortOnWidget,
    description: NewsDescriptionWidget,
    privacidade_dados: PrivacidadeDadosWidget,
  };
  config.widgets.widget = {
    ...config.widgets.widget,
    default_page: DefaultPageWidget,

    html_source: HtmlSourceWidget,
    charCount: CharCountWidget,
    toggle: ToggleWidget,
    publicarTambem: PublicarTambemWidget,
    mpfOndeAtuaTemaAcoes: TemaAcoesWidget,
  };

  config.widgets.views.vocabulary = {
    ...config.widgets.views.vocabulary,
    'ministerio.publico.federal.servico_icones': SelectViewWidget,
    'ministerio.publico.federal.govbr_tipo_acesso': SelectViewWidget,
  };

  config.settings.controlPanelsIcons['footer-settings'] = shareSVG;
  config.settings.controlPanelsIcons['unidade-responsavel-settings'] = usersSVG;
  config.settings.controlPanelsIcons['analytics-settings'] = tagSVG;
};

export default updateWidgetsConfig;
